import React from "react";
import { Card, CardContent } from "ui/components/card";
import { fullName } from "components/employee/utils";
import AvatarDisplay from "components/avatar/display";
import { Icon } from "components";
import { DARKDISCORD } from "icons";
import { Linkedin, Github, Twitter, Globe, Phone } from "lucide-react";

export default function EmployeeInfoCard({ user }) {
  return (
    <div className="w-full p-8">
      <Card className="w-full max-w-7xl mx-auto p-6">
        <CardContent className="p-0">
          <div className="flex justify-between">
            <div className="flex flex-col md:flex-row gap-8 p-8">
              {/* Profile Image */}
              {/* <div className="flex-shrink-0">
                <div className="w-32 h-32 rounded-full bg-gradient-to-br from-orange-300 to-orange-400 flex items-center justify-center overflow-hidden">
                  <div className="w-full h-full flex items-center justify-center">
                    <AvatarDisplay className="w-32 h-32" user={user} />
                  </div>
                </div>
              </div> */}

              {/* Main Info */}
              <div className="flex-1">
                <div className="space-y-2 mb-6">
                  <h1 className="text-3xl font-bold text-gray-900">
                    {fullName(user)}
                  </h1>
                  <p className="text-lgfont-medium">{user.job_title?.name}</p>
                  <p className="text-sm text-muted-foreground">
                    {user.role?.name || user?.user?.role?.name}{" "}
                    • {user.grade?.name}{" "}
                    • {user.function?.name}
                  </p>
                  <p className="text-xs text-muted-foreground"></p>
                  {/* Social Icons */}
                  <div className="flex gap-3 pt-2">
                    {user.phone_no && (
                      <a
                        href={`tel:${user.phone_no}`}
                        className="p-2 rounded-full bg-green-100 text-green-600 hover:bg-green-200 transition-colors"
                        title="Call"
                      >
                        <Phone size={18} />
                      </a>
                    )}
                    {user.website && (
                      <a
                        href={user.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-purple-100 text-purple-600 hover:bg-purple-200 transition-colors"
                        title="Portfolio Website"
                      >
                        <Globe size={18} />
                      </a>
                    )}
                    {user.linkedin && (
                      <a
                        href={user.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                        title="LinkedIn"
                      >
                        <Linkedin size={18} />
                      </a>
                    )}
                    {user.github_username && (
                      <a
                        href={`https://github.com/${user.github_username}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors"
                        title={`GitHub: @${user.github_username}`}
                      >
                        <Github size={18} />
                      </a>
                    )}
                    {user.x && (
                      <a
                        href={user.x}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                        title="Twitter"
                      >
                        <Twitter size={18} />
                      </a>
                    )}
                    {user.discord_user_id && (
                      <a
                        href={`https://discord.com/users/${user.discord_user_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="p-2 rounded-full bg-blue-100 text-blue-800 hover:bg-blue-200 transition-colors"
                        title="Discord"
                      >
                        <Icon icon={DARKDISCORD} className="size-4" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Details Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-10 pr-0 border-l border-gray-200 justify-center">
              <div>
                <p className="text-sm text-gray-500 mb-1">Employee ID</p>
                <p className="text-base text-gray-900 font-medium">
                  {user.employee_id}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Department</p>
                <p className="text-base text-gray-900 font-medium">
                  {user.department?.name}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Reporting Manager</p>
                <div className="flex items-center gap-2">
                  {/* <AvatarDisplay className="w-10 h-10" user={user.reports_to} /> */}
                  <p className="text-base text-gray-900 font-medium">
                    {fullName(user.reports_to)}
                  </p>
                </div>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Phone</p>
                <p className="text-base text-gray-900 font-medium">
                  {user.phone_no}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-1">Email</p>
                <p className="text-base text-gray-900 font-medium">
                  {user.email}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
